import { RoiFrame } from "@inscopix/ideas-hyperformula";
import { chain } from "lodash";
import { ShapeJson } from "types/ToolRoiFrameParamValue/ToolRoiFrameParamValue";
import { BadgePlain } from "../plain/BadgePlain";
import { DATA_TABLE_TOOLTIP_ID } from "../layout/DataTableTooltip";

interface CellValueRendererRoiFrameProps {
  roiFrame: RoiFrame;
}

/** Component that renders an `RoiFrame` cell value` */
export const CellValueRendererRoiFrame = ({
  roiFrame,
}: CellValueRendererRoiFrameProps) => {
  const { shapes } = roiFrame;
  const boundingBox = shapes.find(
    (shape): shape is Extract<ShapeJson, { type: "boundingBox" }> =>
      shape.type === "boundingBox",
  );
  const roiCount = shapes.filter(
    (shape) => shape.type !== "boundingBox",
  ).length;

  return (
    <>
      {boundingBox && (
        <BadgePlain
          color="#d3dae6"
          data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
          data-tooltip-html={[
            boundingBox.name,
            `left: ${Math.round(boundingBox.left)}`,
            `top: ${Math.round(boundingBox.top)}`,
            `width: ${Math.round(boundingBox.width)}`,
            `height: ${Math.round(boundingBox.height)}`,
          ].join("<br />")}
        >
          {Math.round(boundingBox.left)},{Math.round(boundingBox.top)},
          {Math.round(boundingBox.width)},{Math.round(boundingBox.height)}
        </BadgePlain>
      )}

      {roiCount > 0 && (
        <BadgePlain
          color="#d3dae6"
          data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
          // TODO: Display group name when column definitions are implemented
          data-tooltip-html={chain(shapes)
            .groupBy((shape) => shape.groupKey)
            .entries()
            .map(([groupKey, shapes]) => `${groupKey}: ${shapes.length} ROIs`)
            .join("<br />")
            .value()}
        >
          {roiCount} ROIs
        </BadgePlain>
      )}
    </>
  );
};
